var alerts = {}
alerts.success = function (message,$message,offset = 200) {
    $message({
        type: "success",
        message: message,
        offset: offset
      });
} 
alerts.error = function (message,$message,offset = 200) {
    $message({
        type: "error",
        message: message,
        offset: offset
      });
} 

alerts.install = function (Vue) {
  Vue.prototype.$alerts = alerts
  Vue.alerts = alerts
}
export default alerts